import { connectRouter } from 'connected-react-router'
import { combineReducers } from 'redux';
import { ModelReducer } from './reducer.module';
import { UserReducer } from './reducer.user';
import { UserAuthReducer } from './reducer.userAuth';
import { UserDashboardReducer } from './reducer.userDashboard';
import { SurveyReducer } from './reducer.survey';
import { CommonReducer } from './reducer.common';



export default (history: any) => combineReducers({
  router: connectRouter(history),
  model: ModelReducer,
  user: UserReducer,
  userAuth: UserAuthReducer,
  survey: SurveyReducer,
  common: CommonReducer,
  userDashboard: UserDashboardReducer
});


// WEBPACK FOOTER //
// ./src/reducers/reducer.root.tsx